angular.module('env.data.models.customFieldAwareModel', [])

    .config(function (restProvider, RepresentationModelFieldTypes) {
        restProvider.defineModel("CustomFieldAwareModel",
            {
                fields: {
                    customFields: {
                        subResource: true,
                        type: RepresentationModelFieldTypes.DYNAMIC,
                        get: function (rest, model) {
                            return rest
                                .map(model.getDefinition())
                                .map(model)
                                .map("customfields")
                                .get()
                                .then(function (customFields) {
                                    var cfObject = {};
                                    cfObject.$sourceTypes = {};

                                    _.forEach(customFields, function (cf) {
                                        if (cf && cf.fieldCode && !_.isUndefined(cf.type) && !_.isNull(cf.type)) {

                                            cfObject.$sourceTypes[cf.fieldCode] = cf.type;

                                            if (_.isUndefined(cf.value) || _.isNull(cf.value)) {
                                                cfObject[cf.fieldCode] = null;
                                            } else if (cf.type == "String" || cf.type == 0) {
                                                cfObject[cf.fieldCode] = cf.value;
                                            } else if (cf.type == "Text" || cf.type == 1) {
                                                cfObject[cf.fieldCode] = cf.value;
                                            } else if (cf.type == "Integer" || cf.type == 2) {
                                                cfObject[cf.fieldCode] = parseInt(cf.value);
                                            } else if (cf.type == "FloatingPoint" || cf.type == 3) {
                                                cfObject[cf.fieldCode] = parseFloat(cf.value);
                                            } else if (cf.type == "Money" || cf.type == 4) {
                                                cfObject[cf.fieldCode] = parseFloat(cf.value);
                                            } else if (cf.type == "Boolean" || cf.type == 5) {
                                                cfObject[cf.fieldCode] = !!(
                                                cf.value == true ||
                                                cf.value.toLowerCase() == "true" ||
                                                cf.value == "1" ||
                                                cf.value.toLowerCase() == "yes");
                                            } else if (cf.type == "DateTime" || cf.type == 6) {
                                                try {
                                                    cfObject[cf.fieldCode] = new Date(cf.value);
                                                } catch (error) {
                                                    $log.warn(
                                                        "Incorrect date format in server object. Model type: %s; Field name: %s; Server value: %s",
                                                        model.getType(),
                                                        "customFields",
                                                        cf.value,
                                                        error);
                                                    cfObject[cf.fieldCode] = null;
                                                }
                                            } else if (cf.type == "Binary" || cf.type == 7) {
                                                cfObject[cf.fieldCode] = cf.value; // todo parse binary
                                            } else {
                                                cfObject[cf.fieldCode] = cf.value;
                                            }
                                        }
                                    });

                                    return cfObject;
                                });
                        },

                        save: function (rest, model) {
                            var customFields = [];

                            _.forEach(model.$model.customFields, function (value, code) {
                                if (code == "$sourceTypes") {
                                    return;
                                }

                                var cf = {
                                    type: model.$model.customFields.$sourceTypes[code],
                                    fieldCode: code
                                };

                                if (_.isUndefined(value) || _.isNull(value)) {
                                    cf.value = null;
                                } else if (cf.type == "String" || cf.type == 0) {
                                    cf.value = value.toString();
                                } else if (cf.type == "Text" || cf.type == 1) {
                                    cf.value = value.toString();
                                } else if (cf.type == "Integer" || cf.type == 2) {
                                    cf.value = value.toString();
                                } else if (cf.type == "FloatingPoint" || cf.type == 3) {
                                    cf.value = value.toString();
                                } else if (cf.type == "Money" || cf.type == 4) {
                                    cf.value = value.toString();
                                } else if (cf.type == "Boolean" || cf.type == 5) {
                                    cf.value = value.toString();
                                } else if (cf.type == "DateTime" || cf.type == 6) {
                                    if (_.isDate(value)) {
                                        cf.value = value.toISOString();
                                    } else {
                                        cf.value = value.toString();
                                    }
                                } else if (cf.type == "Binary" || cf.type == 7) {
                                    cf.value = value.toString(); // todo parse binary
                                } else {
                                    cf.value = value;
                                }


                                customFields.push(cf);
                            });

                            return rest
                                .map(model.getDefinition())
                                .map(model)
                                .map("customfields")
                                .put(customFields);
                        }
                    }
                }
            }
        );
    })

;